import type { InternalStatusCode } from './generated/schemas';

export interface Envelope<T> {
    status?: InternalStatusCode;
    value?: T;
    errors?: Record<string, string[]>;
    ok: boolean;
}

export const isOk = <T extends { status?: InternalStatusCode | number; value?: unknown }>(
    env: T | undefined,
): env is T & { value: NonNullable<T['value']>; ok: true } =>
    !!env && (env.status as number | undefined) === 200;

// Controllers key their errors by field name ("player", "name", "Error"), so reading a single
// well-known key drops the message the backend actually wrote.
export function firstError(env: { errors?: Record<string, string[] | null> | null } | undefined): string | undefined {
    for (const messages of Object.values(env?.errors ?? {})) {
        const message = messages?.find(m => !!m?.trim());
        if (message) return message;
    }
    return undefined;
}
